"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressUnitField = exports.TagUnitField = exports.MeterCodeUnitField = exports.MeterManufacturerUnitField = exports.MeterCustomerIDUnitField = exports.MeterIDUnitField = exports.TimeUnitField = exports.NameUnitField = exports.UUIDUnitField = void 0;

var field_1 = require("./field");
/* Fields requiring only unit */


var UUIDUnitField =
/** @class */
function () {
  function UUIDUnitField() {
    this.name = "uuid";
    this.displayName = "UUID";
    this.sortable = true;
    this.numeric = false;
    this.requiresObject = field_1.Field.Meter;
  }

  UUIDUnitField.prototype.value = function (unit) {
    return unit.uuid.string();
  };

  UUIDUnitField.prototype.compare = function (a, b) {
    return this.value(a).localeCompare(this.value(b));
  };

  return UUIDUnitField;
}();

exports.UUIDUnitField = UUIDUnitField;

var NameUnitField =
/** @class */
function () {
  function NameUnitField() {
    this.name = "assetid";
    this.displayName = "Name";
    this.sortable = true;
    this.numeric = false;
    this.requiresObject = field_1.Field.Meter;
  }

  NameUnitField.prototype.value = function (unit) {
    return unit.assetid;
  };

  NameUnitField.prototype.compare = function (a, b) {
    return this.value(a).localeCompare(this.value(b));
  };

  return NameUnitField;
}();

exports.NameUnitField = NameUnitField;

var TimeUnitField =
/** @class */
function () {
  function TimeUnitField() {
    this.name = "time";
    this.displayName = "Time";
    this.sortable = true;
    this.numeric = false;
    this.requiresObject = field_1.Field.Meter;
  }

  TimeUnitField.prototype.value = function (unit) {
    return unit.lastSeen.toLocaleString();
  };

  TimeUnitField.prototype.compare = function (a, b) {
    return a.lastSeen.getTime() - b.lastSeen.getTime();
  };

  return TimeUnitField;
}();

exports.TimeUnitField = TimeUnitField;
/* meter fields */

var MeterIDUnitField =
/** @class */
function () {
  function MeterIDUnitField() {
    this.name = "meterid";
    this.displayName = "Meter ID";
    this.sortable = true;
    this.numeric = false;
    this.requiresObject = field_1.Field.Meter;
  }

  MeterIDUnitField.prototype.value = function (unit) {
    if (unit.meters != null && unit.meters.length > 0 && unit.meters[0].id != null && unit.meters[0].id !== "" && unit.meters[0].id !== "0") {
      return unit.meters[0].id;
    }

    return unit.giai;
  };

  MeterIDUnitField.prototype.compare = function (a, b) {
    return this.value(a).localeCompare(this.value(b));
  };

  return MeterIDUnitField;
}();

exports.MeterIDUnitField = MeterIDUnitField;

var MeterCustomerIDUnitField =
/** @class */
function () {
  function MeterCustomerIDUnitField() {
    this.name = "metercustomerid";
    this.displayName = "Meter Customer ID";
    this.sortable = true;
    this.numeric = false;
    this.requiresObject = field_1.Field.Meter;
  }

  MeterCustomerIDUnitField.prototype.value = function (unit) {
    return unit.meters[0].customerID;
  };

  MeterCustomerIDUnitField.prototype.compare = function (a, b) {
    return this.value(a).localeCompare(this.value(b));
  };

  return MeterCustomerIDUnitField;
}();

exports.MeterCustomerIDUnitField = MeterCustomerIDUnitField; // This is in the process of being replaced with the new model thing

var MeterManufacturerUnitField =
/** @class */
function () {
  function MeterManufacturerUnitField() {
    this.name = "metermanufacturer";
    this.displayName = "Meter Manufacturer";
    this.sortable = true;
    this.numeric = false;
    this.requiresObject = field_1.Field.Model;
  }

  MeterManufacturerUnitField.prototype.value = function (unit) {
    if (unit.meters != null && unit.meters.length > 0 && unit.meters[0].manufacturer != null && unit.meters[0].manufacturer !== "") {
      return unit.meters[0].manufacturer;
    }

    return unit.model.manufacturer;
  };

  MeterManufacturerUnitField.prototype.compare = function (a, b) {
    return this.value(a).localeCompare(this.value(b));
  };

  return MeterManufacturerUnitField;
}();

exports.MeterManufacturerUnitField = MeterManufacturerUnitField;

var MeterCodeUnitField =
/** @class */
function () {
  function MeterCodeUnitField() {
    this.name = "metercode";
    this.displayName = "Meter Model Code";
    this.sortable = true;
    this.numeric = false;
    this.requiresObject = field_1.Field.Meter;
  }

  MeterCodeUnitField.prototype.value = function (unit) {
    if (unit.meters != null && unit.meters.length > 0 && unit.meters[0].code != null && unit.meters[0].code !== "") {
      return unit.meters[0].code;
    }

    return unit.model.model;
  };

  MeterCodeUnitField.prototype.compare = function (a, b) {
    return this.value(a).localeCompare(this.value(b));
  };

  return MeterCodeUnitField;
}();

exports.MeterCodeUnitField = MeterCodeUnitField;
/* location fields */

var TagUnitField =
/** @class */
function () {
  function TagUnitField() {
    this.name = "tag";
    this.displayName = "Tag";
    this.sortable = true;
    this.numeric = false;
    this.requiresObject = field_1.Field.Location;
  }

  TagUnitField.prototype.value = function (unit) {
    return unit.location.name;
  };

  TagUnitField.prototype.compare = function (a, b) {
    return this.value(a).localeCompare(this.value(b));
  };

  return TagUnitField;
}();

exports.TagUnitField = TagUnitField;

var AddressUnitField =
/** @class */
function () {
  function AddressUnitField() {
    this.name = "address";
    this.displayName = "Site Address";
    this.sortable = true;
    this.numeric = false;
    this.requiresObject = field_1.Field.Location;
  }

  AddressUnitField.prototype.value = function (unit) {
    return unit.location.address;
  };

  AddressUnitField.prototype.compare = function (a, b) {
    return this.value(a).localeCompare(this.value(b));
  };

  return AddressUnitField;
}();

exports.AddressUnitField = AddressUnitField;